import { getOrCreatePreviewRpc } from '../../__generated__/chirp/com/hubspot/copilot/rpc/v2/CopilotPreviewService';
import { rpcClient } from './rpcClient';
export const fetchCopilotPreviewV2 = request => {
  return rpcClient.call(getOrCreatePreviewRpc, {
    request
  });
};